import React, { useState } from 'react';
import {
  Col,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  ButtonGroup,
  FormText,
} from 'reactstrap';
import FormErrorMessage from '../../commons/FormErrorMessage';
import Autosuggest from '../../commons/Autosuggest';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import {
  BtnRadiusRed,
  ButtonSave,
  H5Styled,
  ContFlexRight,
} from '../../styled-components';
import plusTrash from '../../images/icn-trash.svg';
import { ReactComponent as IconPlus } from '../../images/icn-plus.svg';

const renderCondoSuggestion = ({ name = '' }) => name;
const getCondoSuggestionValue = ({ name = '' }) => name;

const INITIAL_FORM_STATE = {
  condo: {
    _id: '',
    name: '',
  },
};

const SailInvoice = ({
  data = {},
  subjects = [],
  onSendInvoice,
  searchCondos,
  searchSdiProfile,
}) => {
  const [t] = useTranslation('SAIL_INVOICES');
  const makeInitialOrderRow = () => ({
    product: {
      title: '',
      pricing: {
        list: 0,
      },
    },
    quantity: 1,
  });

  const [orderRows, setOrderRows] = useState({
    1: [makeInitialOrderRow()],
    2: [makeInitialOrderRow()],
  });
  const [activeTab, setActiveTab] = useState('1');
  const [formValues, setFormValues] = useState(INITIAL_FORM_STATE);
  const [formErrors, setFormErrors] = useState({ condo: false });

  const [sdiCondo, setSdiCondo] = useState('');
  const [sdiOwner, setSdiOwner] = useState('');

  const orderRow = orderRows[activeTab];

  const handleCheck = (index, e, selected) => {
    let temp = [...orderRow];
    setNestedProperty(temp[index], selected, e.target.value);
    setOrderRows({ ...orderRows, [activeTab]: temp });
  };

  const setNestedProperty = (obj, path, value) =>
    path
      .split('.')
      .reduce(
        (o, k, i, a) =>
          i === a.length - 1 ? (o[k] = value) : (o[k] = o[k] || {}),
        obj
      );

  const handleNewRow = () => {
    setOrderRows({
      ...orderRows,
      [activeTab]: [...orderRow, makeInitialOrderRow()],
    });
  };

  const handleRemoveRow = (index) => {
    const temp = [...orderRow];
    temp.splice(index, 1);
    setOrderRows({ ...orderRows, [activeTab]: temp });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (activeTab === '2') {
      if (!formValues.condo._id) {
        setFormErrors((state) => ({ ...state, condo: true }));
        return;
      }
      onSendInvoice({
        condoId: formValues.condo._id,
        item: orderRow,
      });
      setFormValues(INITIAL_FORM_STATE);
      setSdiCondo('');
      setSdiOwner('');
      setFormErrors({ condo: false });
    } else {
      onSendInvoice({
        profileId: e.target.profileId.value,
        item: orderRow,
      });
    }
    setOrderRows({ ...orderRows, [activeTab]: [makeInitialOrderRow()] });
    e.target.reset();
  };

  const { register, errors } = useForm({
    mode: 'onChange',
    defaultValues: data,
  });

  async function onCondoSuggestionSelect({ _id, name, sdi }) {
    setFormValues((state) => ({
      ...state,
      condo: { _id, name },
    }));
    setSdiCondo(sdi);
    const sdiProfile = await searchSdiProfile(_id);
    console.log('sdiProfile:', sdiProfile);

    if (sdiProfile && sdiProfile._id) {
      setSdiOwner(sdiProfile.name);
    } else {
      setSdiOwner(name);
    }
    setFormErrors((state) => ({ ...state, condo: false }));
  }

  return (
    <Form onSubmit={handleSubmit}>
      <div className="m-tb-20">
        <Nav tabs>
          <NavItem>
            <NavLink
              className={activeTab === '1' ? 'active' : ''}
              onClick={() => setActiveTab('1')}
            >
              Nuova fattura
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={activeTab === '2' ? 'active' : ''}
              onClick={() => setActiveTab('2')}
            >
              Nuova fattura condomino
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              <Col sm="12" md="6" lg="3">
                <FormGroup>
                  <Label>{t('SUBJECT')}</Label>
                  <CustomInput
                    type="select"
                    id="profileId"
                    name="type"
                    innerRef={register({ required: t('COMMON:REQUIRED') })}
                  >
                    {subjects.map((subject) => (
                      <option value={subject._id} key={subject._id}>
                        {subject.businessName}
                      </option>
                    ))}
                  </CustomInput>
                  <FormErrorMessage errors={errors} name="type" />
                </FormGroup>
              </Col>
            </Row>
            <br />
            <H5Styled>{t('ORDER_ROW')}</H5Styled>
            {orderRow.map((row, index) => (
              <Row key={index}>
                <Col sm="12" md="6" lg="6">
                  <FormGroup>
                    <Label>{t('TEXT')}</Label>
                    <Input
                      type="text"
                      name="title"
                      onChange={(e) => handleCheck(index, e, 'product.title')}
                      innerRef={register({
                        required: t('COMMON:REQUIRED'),
                        maxLength: 500,
                      })}
                    />
                    <FormErrorMessage errors={errors} name="businessName" />
                  </FormGroup>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <FormGroup>
                    <Label>{t('AMOUNT')}</Label>
                    <Input
                      type="number"
                      step={0.01}
                      min={0}
                      name="list"
                      onChange={(e) =>
                        handleCheck(index, e, 'product.pricing.list')
                      }
                      innerRef={register({
                        required: t('COMMON:REQUIRED'),
                      })}
                    />
                    <FormErrorMessage errors={errors} name="name" />
                  </FormGroup>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <ButtonGroup className="mt-4">
                    {index !== 0 && (
                      <BtnRadiusRed type="button" className="mr-3">
                        <img
                          src={plusTrash}
                          alt="Elimina"
                          onClick={() => handleRemoveRow(index)}
                        />
                      </BtnRadiusRed>
                    )}
                    {index === orderRow.length - 1 && (
                      <BtnRadiusRed type="button" onClick={handleNewRow}>
                        <IconPlus />
                      </BtnRadiusRed>
                    )}
                  </ButtonGroup>
                </Col>
              </Row>
            ))}
          </TabPane>

          <TabPane tabId="2">
            <Row>
              <Col sm="12" md="6" lg="3">
                <FormGroup>
                  <Label>{t('SUBJECT')}</Label>
                  <Autosuggest
                    placeholder="Cerca un condominio..."
                    onFetch={searchCondos}
                    onSelect={onCondoSuggestionSelect}
                    renderSuggestion={renderCondoSuggestion}
                    getSuggestionValue={getCondoSuggestionValue}
                    value={formValues.condo.name}
                    onChange={(name) =>
                      setFormValues((state) => ({
                        ...state,
                        condo: { _id: '', name },
                      }))
                    }
                  />
                  {formErrors.condo && (
                    <FormText className="error-message">
                      {t('COMMON:REQUIRED')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>

              <Col sm="12" md="6" lg="3">
                <FormGroup>
                  <Label>{t('SDI_CONDO')}</Label>
                  <Input
                    type="text"
                    name="sdiCondo"
                    value={sdiCondo}
                    disabled
                  />
                </FormGroup>
              </Col>

              <Col sm="12" md="6" lg="6">
                <FormGroup>
                  <Label>{t('SDI_OWNER')}</Label>
                  <Input
                    type="text"
                    name="sdiOwner"
                    value={sdiOwner}
                    disabled
                  />
                </FormGroup>
              </Col>
            </Row>
            <br />
            <H5Styled>{t('ORDER_ROW')}</H5Styled>
            {orderRow.map((row, index) => (
              <Row key={index}>
                <Col sm="12" md="6" lg="6">
                  <FormGroup>
                    <Label>{t('TEXT')}</Label>
                    <Input
                      type="text"
                      name="condoTitle"
                      onChange={(e) => handleCheck(index, e, 'product.title')}
                      innerRef={register({
                        required: t('COMMON:REQUIRED'),
                        maxLength: 500,
                      })}
                    />
                    <FormErrorMessage errors={errors} name="condoTitle" />
                  </FormGroup>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <FormGroup>
                    <Label>{t('AMOUNT')}</Label>
                    <Input
                      type="number"
                      step={0.01}
                      min={0}
                      name="condoList"
                      onChange={(e) =>
                        handleCheck(index, e, 'product.pricing.list')
                      }
                      innerRef={register({
                        required: t('COMMON:REQUIRED'),
                      })}
                    />
                    <FormErrorMessage errors={errors} name="condoList" />
                  </FormGroup>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <FormGroup>
                    <Label>{t('WITHHOLDING_TAX')}</Label>
                    <Input
                      type="number"
                      step={0.01}
                      name="condoWithholdingTax"
                      value={
                        parseFloat(row.product.pricing.list) > 0
                          ? (
                              parseFloat(row.product.pricing.list) * 0.04
                            ).toFixed(2)
                          : ''
                      }
                      disabled
                      readOnly
                    />
                  </FormGroup>
                </Col>
                <Col sm="12" md="2" lg="2">
                  <ButtonGroup className="mt-4">
                    {index !== 0 && (
                      <BtnRadiusRed type="button" className="mr-3">
                        <img
                          src={plusTrash}
                          alt="Elimina"
                          onClick={() => handleRemoveRow(index)}
                        />
                      </BtnRadiusRed>
                    )}
                    {index === orderRow.length - 1 && (
                      <BtnRadiusRed type="button" onClick={handleNewRow}>
                        <IconPlus />
                      </BtnRadiusRed>
                    )}
                  </ButtonGroup>
                </Col>
              </Row>
            ))}
          </TabPane>
        </TabContent>
      </div>
      <ContFlexRight>
        <div className="m-b-30">
          <ButtonSave type="submit">{t('BTN_SAVE')}</ButtonSave>
        </div>
      </ContFlexRight>
    </Form>
  );
};

export default SailInvoice;
